import { useApi } from "@platform/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createCarrierRep, updateCarrierRep } from "../api/client";

import { CARRIERS_QUERY_KEY } from "./useCarriersQuery";

import type { UseMutationResult } from "@tanstack/react-query";
import type { CarrierRepRequest, CarrierRepResponse } from "../api/types";

export const useSaveCarrierRepMutation = (
  carrierId: number,
  carrierRepId?: number,
): UseMutationResult<CarrierRepResponse, Error, CarrierRepRequest> => {
  const axiosInstance = useApi();
  const queryClient = useQueryClient();

  return useMutation<CarrierRepResponse, Error, CarrierRepRequest>({
    mutationFn: (request) =>
      carrierRepId === undefined
        ? createCarrierRep(axiosInstance, carrierId, request)
        : updateCarrierRep(axiosInstance, carrierId, carrierRepId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CARRIERS_QUERY_KEY }),
  });
};
